module.exports = __webpack_public_path__ + "static/media/2a.12bbe722.png";